import { render, staticRenderFns } from "./portrait-card-item.vue?vue&type=template&id=6f732cb5&scoped=true&"
import script from "./portrait-card-item.vue?vue&type=script&lang=ts&"
export * from "./portrait-card-item.vue?vue&type=script&lang=ts&"
import style0 from "./portrait-card-item.vue?vue&type=style&index=0&id=6f732cb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f732cb5",
  null
  
)

export default component.exports